import React,{createContext} from 'react';

const InfoContext =createContext({})
export default InfoContext
